function smoothScrollTo(targetY, duration = 1000) {
    const startY = window.scrollY;
    const distanceY = targetY - startY;
    let startTime = null;

    function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;

        // easing (easeInOutCubic для більш плавного відчуття)
        const progress = Math.min(timeElapsed / duration, 1);
        const ease = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        window.scrollTo(0, startY + distanceY * ease);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }

    requestAnimationFrame(animation);
}

document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.js-menu-toggle'),
          menu = document.querySelector('.js-menu'),
          target = document.querySelector('.js-menu-target'),
          header = document.querySelector('.js-header'); // твій хедер

    if (!buttons.length || !menu || !target || !header) return;

    buttons.forEach((btn) => {
        btn.addEventListener('click', function () {
            menu.classList.toggle('active');
            const isActive = menu.classList.contains('active');

            // Міняємо текст у всіх кнопках
            buttons.forEach(b => {
                const span = b.querySelector('span');
                if (span) {
                    span.textContent = isActive ? 'Hide Menu' : 'Show Menu';
                }
            });

            // Скролимо завжди до js-menu-target з урахуванням хедера
            const headerHeight = header.offsetHeight;
            let targetY = target.getBoundingClientRect().top + window.scrollY - headerHeight;

            // якщо клікнули на кнопку з класом .last → відняти ще 100vh
            if (btn.classList.contains('last')) {
                targetY = targetY - window.innerHeight + headerHeight;
            }

            smoothScrollTo(targetY, 700);
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".js-menu");
  const btn = document.querySelector(".menu-toggle-inside");

  if (section && btn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          btn.classList.add("is-visible");
        } else {
          btn.classList.remove("is-visible");
        }
      });
    }, {
      threshold: 0.1 // % видимості секції, після якого кнопка показується
    });

    observer.observe(section);
  }
});
